<mat-icon class="flex-none text-red-900" svgIcon="{{ icon }}"></mat-icon>
<span class="inline-block font-sans font-semibold text-sm text-red-900 leading-3.5 w-32">{{ text }}</span>

